import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TransitionService } from '@uirouter/core';

export interface BreadcrumbUiState {
    label: string;
    state: string;
}

export interface SetBreadcrumbsParams {
    uiStates: BreadcrumbUiState[];
}

export interface BreadcrumbItem {
    label: string;
    state: string;
}

@Injectable({
    providedIn: 'root',
})
export class AdminLayoutService {
    private breadcrumbsSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
    breadcrumbs$ = this.breadcrumbsSubject.asObservable();

    constructor (private transitionService: TransitionService) {
        this.setupAutoClear();
    }

    setBreadcrumbs (params: SetBreadcrumbsParams): void {
        const { uiStates } = params;
        const items = uiStates.map(uiState => ({
            label: uiState.label,
            state: uiState.state,
        }));
        this.breadcrumbsSubject.next(items);
    }

    clearBreadcrumbs (): void {
        this.breadcrumbsSubject.next([]);
    }

    private setupAutoClear (): void {
        // clear breadcrumbs when navigating to a different state
        this.transitionService.onStart({}, (transition) => {
            const fromState = transition.from()?.name;
            const toState = transition.to()?.name;

            if (fromState && toState && fromState !== toState) {
                this.clearBreadcrumbs();
            }
        });
    }
}
